import { render, staticRenderFns } from "./WhiteboxAbove.vue?vue&type=template&id=3109acfe&scoped=true"
import script from "./WhiteboxAbove.vue?vue&type=script&lang=js"
export * from "./WhiteboxAbove.vue?vue&type=script&lang=js"
import style0 from "./WhiteboxAbove.vue?vue&type=style&index=0&id=3109acfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3109acfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VRow,VSpacer})
